import { action, makeObservable, observable } from 'mobx';

export class AlignmentStore {
    // Alignments may have legacy implementation if the user has not reparsed the model. This store keeps track of that.
    @observable.ref alignmentIndex: Map<string, number | { legacy: boolean }> = new Map();

    constructor() {
        makeObservable(this);
    }

    // Set legacy flag for a specific model
    setModelLegacy(modelId: number, isLegacy: boolean) {
        const legacyKey = `__legacy_${modelId}__`;
        this.alignmentIndex.set(legacyKey, { legacy: isLegacy });
    }

    // Check if a specific model uses legacy lookup
    isModelLegacy(modelId: number): boolean {
        const legacyKey = `__legacy_${modelId}__`;
        const legacyData = this.alignmentIndex.get(legacyKey);
        return legacyData && typeof legacyData === 'object' && 'legacy' in legacyData ? legacyData.legacy : false;
    }

    getAlignmentIndex(key: string): number | undefined {
        const value = this.alignmentIndex.get(key);
        return typeof value === 'number' ? value : undefined;
    }
}
